import React from "react";
import { Menu, MenuItem, Box } from "@mui/material";
import { Link } from "react-router-dom";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { IconGradient, SmallTextGradient } from "../Gradient";
import { getGlassCardStyles } from "../../utility/glassCard.utils";

type ChallengesMenuProps = {
  challengesMenuAnchor: HTMLElement | null;
  challengesMenuOpen: boolean;
  handleChallengesMenuClose: () => void;
  setActive: (key: string) => void;
};

const ChallengesMenu: React.FC<ChallengesMenuProps> = ({
  challengesMenuAnchor,
  challengesMenuOpen,
  handleChallengesMenuClose,
  setActive,
}) => {
  return (
    <Menu
      anchorEl={challengesMenuAnchor}
      open={challengesMenuOpen}
      onClose={handleChallengesMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        elevation: 0,
        sx: (theme) => ({
          ...getGlassCardStyles(theme),
          mt: 1,
          p: 0,
          width: 'auto',
          maxWidth: '92vw',
          borderRadius: 3,
        }),
      }}
    >
      <MenuItem
        component={Link}
        to="/challenges/ink-masters"
        onClick={() => { handleChallengesMenuClose(); setActive('ink-masters'); }}
        sx={(theme) => ({
          px: 3,
          py: 1.25,
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          transition: 'all 0.2s ease',
          borderRadius: 1,
          mx: 1,
          my: 0.5,
          position: 'relative',
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.05)'
              : 'rgba(0,0,0,0.04)',
            '& .menu-text-wrapper::after': {
              transform: 'scaleX(1)',
            },
          },
          '& .menu-text-wrapper': {
            position: 'relative',
            display: 'inline-block',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: -2,
              height: '2px',
              background: theme.palette.mode === 'dark'
                ? 'linear-gradient(90deg, #ffffff 0%, #a5b4fc 100%)'
                : 'linear-gradient(90deg, #1e293b 0%, #3b82f6 100%)',
              borderRadius: '1px',
              transform: 'scaleX(0)',
              transformOrigin: 'left center',
              transition: 'transform 0.2s ease',
            },
          },
        })}
      >
        <IconGradient gradientVariant="default">
          <EmojiEventsIcon fontSize="small" />
        </IconGradient>
        <Box className="menu-text-wrapper">
          <SmallTextGradient variant="body2" gradientVariant="default" sx={{ fontWeight: 600 }}>
            Ink Masters
          </SmallTextGradient>
        </Box>
      </MenuItem>
    </Menu>
  );
};

export default ChallengesMenu;

